import { ControlCsvHeaders } from 'src/api/types/misc';
import _ from 'lodash';
import { ControlCSV, FrameworkControlPair } from './types';
import { ControlFrameworksListQuery } from 'src/graphql/_generated';

export const generateCsvTemplateLink = () => {
  const csvString = Object.values(ControlCsvHeaders).join(';') + '\n';
  const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
  return URL.createObjectURL(blob);
};

const _parseFrameworkControlPairs = (headers: string[], rowData: Record<string, any>): FrameworkControlPair[] => {
  const pairs: FrameworkControlPair[] = [];
  const processedIndices = new Set<number>();

  for (let i = 0; i < headers.length - 1; i++) {
    if (processedIndices.has(i)) continue;

    const currentHeader = headers[i];
    const nextHeader = headers[i + 1];

    const isFrameworkColumn =
      currentHeader === ControlCsvHeaders.Framework || currentHeader.startsWith(`${ControlCsvHeaders.Framework}_`);
    const isNextControlIdColumn =
      nextHeader === ControlCsvHeaders.FrameworkControlID ||
      nextHeader.startsWith(`${ControlCsvHeaders.FrameworkControlID}_`);

    if (isFrameworkColumn && isNextControlIdColumn) {
      const frameworkValue = rowData[currentHeader];
      const controlIdValue = rowData[nextHeader];

      if (frameworkValue && controlIdValue && String(frameworkValue).trim() && String(controlIdValue).trim()) {
        pairs.push({
          framework: String(frameworkValue).trim(),
          controlId: String(controlIdValue).trim(),
        });
      }

      processedIndices.add(i);
      processedIndices.add(i + 1);
    } else if (
      isFrameworkColumn ||
      currentHeader === ControlCsvHeaders.FrameworkControlID ||
      currentHeader.startsWith(`${ControlCsvHeaders.FrameworkControlID}_`)
    ) {
      processedIndices.add(i);
    }
  }

  return pairs;
};

export const getFrameworkControlIds = (
  row: ControlCSV,
  frameworksList: ControlFrameworksListQuery | undefined = { controlFrameworks: [] },
): string[] => {
  const headers = Object.keys(row);
  const pairs = _parseFrameworkControlPairs(headers, row);

  const frameworkControlIds: string[] = [];

  if (frameworksList?.controlFrameworks && pairs.length > 0) {
    pairs.forEach((pair) => {
      const framework = frameworksList.controlFrameworks.find((fw) => fw.shortname === pair.framework);

      if (framework) {
        const frameworkControl = framework.frameworkControls.find((fc) => fc.control_identifier === pair.controlId);

        if (frameworkControl) {
          frameworkControlIds.push(frameworkControl.id);
        }
      }
    });
  }

  // return frameworkControlIds;
  return [frameworkControlIds[0]];
};

export const pathNames = {
  id: ControlCsvHeaders.ID,
  name: ControlCsvHeaders.Name,
  strategy: ControlCsvHeaders.Strategy,
  status: ControlCsvHeaders.Status,
  owner: ControlCsvHeaders.Owner,
  annualCost: ControlCsvHeaders.AnnualCost,
  vendor: ControlCsvHeaders.Vendor,
  expectedActiveDate: ControlCsvHeaders.ExpectedLiveDate,
  actualActiveDate: ControlCsvHeaders.ActualLiveDate,
  reviewDate: ControlCsvHeaders.ReviewDate,
  description: ControlCsvHeaders.Description,
  shortname: ControlCsvHeaders.Framework,
  origin: ControlCsvHeaders.Source,
  linkText: ControlCsvHeaders.UrlName,
};

export const isValidHeaders = (data: ControlCSV) => {
  const expectedHeaders = Object.values(ControlCsvHeaders).map(String);
  const parsedHeaders = Object.keys(data);
  const missingElements = _.difference(expectedHeaders, parsedHeaders);
  return missingElements.length === 0;
};
